const tableSectionHighlight = 'table-section-highlight';

export default tableSectionHighlight;
